var a="#13181D";export{a as default};
